import { render, staticRenderFns } from "./VEditor.vue?vue&type=template&id=0edd5642&"
import script from "./VEditor.vue?vue&type=script&lang=js&"
export * from "./VEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports